import { Injectable, EventEmitter } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import {
  SignalRService,
  SignalREventService,
  DataArray,
  DocumentPartMap,
  Attribute,
  AttributeMaps,
  DeleteConfirmation,
} from "./../index";

@Injectable()
export class GlobalService {
  public versionChange: EventEmitter<string> = new EventEmitter<string>();
  public datasetSourceChange: EventEmitter<string> = new EventEmitter<string>();
  public beginDeleteConfirmation: EventEmitter<DeleteConfirmation> =
    new EventEmitter<DeleteConfirmation>();

  public pushNoticeSent: EventEmitter<string> = new EventEmitter<string>();

  public deleteResult: EventEmitter<boolean> = new EventEmitter<boolean>();
  public deleteResultEx: EventEmitter<DeleteConfirmation> =
    new EventEmitter<DeleteConfirmation>();

  public datasetSource = "";
  public webVersion = "";
  public iosVersion = "";
  public uwpVersion = "";
  public uwpSLVersion = "";

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService
  ) {
    this.registerOnServerEvents();
  }

  public confirmDelete(
    entityType: string,
    entityName: string,
    entityId: number
  ): void {
    const state: DeleteConfirmation = new DeleteConfirmation();
    state.EntityType = entityType;
    state.FriendlyName = entityName;
    state.EntityId = entityId;
    this.beginDeleteConfirmation.emit(state);
  }

  public getVersion(): void {
    this._signalRService.invoke("GetVersion");
  }

  private onVersion(info: any): void {
    this.versionChange.emit(info);
  }

  public getDatasetSource(): void {
    this._signalRService.invoke("GetDatasetSource");
  }

  private onDatasetSource(info: any): void {
    this.datasetSourceChange.emit(info);
  }

  private onBroadcastedChange(user: any): void {
    this.pushNoticeSent.emit(user);
  }

  //20200307 mrose - remove notifications
  //public broadcastPush(): void {
  //    this._signalRService.invoke("BroadcastPush", window.localStorage.getItem("user"));
  //}

  private registerOnServerEvents() {
    this._signalREventService.registerAdvanced(this, "version", (info: any) =>
      this.onVersion(info)
    );
    this._signalREventService.registerAdvanced(this, "dbSource", (info: any) =>
      this.onDatasetSource(info)
    );
    this._signalREventService.registerAdvanced(
      this,
      "brodcastedChanges",
      (user: any) => this.onBroadcastedChange(user)
    );
  }

  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("GobalService");
  }
  private LockEnvironment = new BehaviorSubject("");
  SetEnvironmentLocked = this.LockEnvironment.asObservable();

  TriggerLockEnvironment(TabId: any) {
    this.LockEnvironment.next(TabId);
  }
}
